import AntdSegmented                            from 'antd/lib/segmented';

export type SegmentedProps = React.ComponentProps<typeof AntdSegmented>;

const Segmented = AntdSegmented;

export default Segmented;
